import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  CheckoutRoute,
  useCheckoutRouter,
} from '@src/hooks/useCheckoutRouter/useCheckoutRouter'
import { useBasketTotalsContext } from '@src/hooks/useTotals/BasketTotalsContext'

import {
  LoyaltyCardAmountBold,
  LoyaltyCardText,
} from '../CustomerLoyaltyCard.styles'

import {
  DiscountCircleText,
  DiscountIcon,
  ExtraInfoAndAmountEarnedContainer,
  IconTextAndDetailsContainer,
  RewardNameContainer,
  TextAndIconContainer,
} from './CheckoutRewards.styles'

import { useFormatCurrency } from '@src/hooks/useFormatCurrency'
import { allOutletDiscountsQuery } from '@src/hooks/sharedQueries/useAllDiscounts/queries/__generated__/getAllDiscounts.graphql-interface'
import { TextClamp } from '@src/components/Text/Clamp'

export const DiscountDealsSection: React.FC<{
  basketSubTotal: number
  discountData: allOutletDiscountsQuery | undefined
}> = ({ basketSubTotal, discountData }) => {
  const { t } = useTranslation('customerLoyaltyCard')
  const { basketTotals } = useBasketTotalsContext()
  const checkout = useCheckoutRouter()
  const formatCurrency = useFormatCurrency()
  const formatCurrencyNoDecimal = useFormatCurrency(false)

  if (!discountData) {
    return null
  }

  const calculatedBiggestDiscount =
    basketTotals.data?.checkoutBasketTotals?.bestPotentialDiscount?.discount

  const isDiscountWholeNumber =
    calculatedBiggestDiscount?.discountAmount != null &&
    calculatedBiggestDiscount.discountAmount % 1 === 0

  const getDiscountDisplayText = () => {
    if (!calculatedBiggestDiscount?.discountAmount) {
      return `${calculatedBiggestDiscount?.discountPercentage}%`
    }

    return isDiscountWholeNumber
      ? formatCurrencyNoDecimal(calculatedBiggestDiscount.discountAmount)
      : formatCurrency(calculatedBiggestDiscount.discountAmount)
  }

  const discountDisplayText = getDiscountDisplayText()
  const useLargeText = discountDisplayText.length <= 2

  const isBasketView =
    checkout.route === CheckoutRoute.BASKET || checkout.route === undefined

  return (
    <>
      {calculatedBiggestDiscount &&
      (isBasketView ||
        !calculatedBiggestDiscount.minimumSubtotalGross ||
        (calculatedBiggestDiscount.minimumSubtotalGross &&
          basketSubTotal > calculatedBiggestDiscount.minimumSubtotalGross)) ? (
        <>
          <IconTextAndDetailsContainer>
            <TextAndIconContainer>
              <DiscountIcon>
                <DiscountCircleText largeText={useLargeText}>
                  {discountDisplayText}
                </DiscountCircleText>
              </DiscountIcon>
              <RewardNameContainer color={'discount'}>
                <TextClamp tooltipText={calculatedBiggestDiscount.name}>
                  {calculatedBiggestDiscount.name}
                </TextClamp>
              </RewardNameContainer>
            </TextAndIconContainer>
            <ExtraInfoAndAmountEarnedContainer>
              {' '}
              {calculatedBiggestDiscount.minimumSubtotalGross &&
              basketSubTotal <
                calculatedBiggestDiscount.minimumSubtotalGross ? (
                <LoyaltyCardText isBasket={true} isTermsPage={false}>
                  {t('spend')}{' '}
                  <LoyaltyCardAmountBold isBasket={true}>
                    {' '}
                    {formatCurrency(
                      calculatedBiggestDiscount.minimumSubtotalGross -
                        basketSubTotal
                    )}
                  </LoyaltyCardAmountBold>{' '}
                  {t('to_earn')}
                </LoyaltyCardText>
              ) : (
                <LoyaltyCardText isBasket={true} isTermsPage={false}>
                  {t('saved')}{' '}
                  <LoyaltyCardAmountBold isBasket={true}>
                    {formatCurrency(
                      basketTotals.data?.checkoutBasketTotals?.appliedDiscount
                        ?.reductionAmount ?? 0
                    )}
                  </LoyaltyCardAmountBold>
                </LoyaltyCardText>
              )}
            </ExtraInfoAndAmountEarnedContainer>
          </IconTextAndDetailsContainer>
        </>
      ) : null}
    </>
  )
}
